module.exports = __webpack_public_path__ + "img/login_google.eb3d489b.svg";